var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding":"0"},attrs:{"fluid":"","fill-height":""}},[_c('SettingsDrawer',{attrs:{"isOpened":_vm.isDrawerOpened}}),_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }